import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { XmDirectivesModule, XmSidebarModule } from '@optek/xm-bootstrap';
import { NavBarComponent } from './nav-bar.component';
import { NavBarService } from './nav-bar.service';


@NgModule({
    imports: [
        CommonModule,
        XmSidebarModule,
        XmDirectivesModule,
    ],
    declarations: [
        NavBarComponent,
    ],
    exports: [
        NavBarComponent
    ],
    providers: [
        NavBarService
    ]
})
export class NavBarModule { }
